export type Lang = 'ar' | 'en';

export const STRINGS = {
  onboarding: {
    title: { ar: 'مرصد اعتماد', en: 'Marsad Etimad' },
    subtitle: {
      ar: 'مساعد ذكي للبحث في مناقصات اعتماد',
      en: 'A smart assistant for Etimad tender intelligence',
    },
    badge: { ar: 'ورشة تطوير', en: 'Tatweer Workshop' },
    step1Title: { ar: 'الاسم', en: 'Name' },
    step1Subtitle: {
      ar: 'سنستخدم اسمك الأول فقط في المحادثة',
      en: 'We will only use your first name in the chat',
    },
    step2Greeting: { ar: 'مرحباً {name} 👋', en: 'Hi {name} 👋' },
    step2Title: {
      ar: 'برأيك، أي جامعة تتصدّر بإجمالي قيمة مناقصاتها على اعتماد؟',
      en: 'Which university leads by total tender value on Etimad?',
    },
    step2Subtitle: {
      ar: 'اختر الجامعة التي تظنّ أنها أنفقت الأعلى على مناقصات اعتماد — القيمة بمليارات الريال — وستُحسب الأصوات لحظياً على شاشة الورشة',
      en: 'Pick the university you think spent the most on Etimad tenders (in SAR billions) — votes appear live on the workshop board',
    },
    nameLabel: { ar: 'اسمك الأول', en: 'Your first name' },
    namePlaceholder: { ar: '', en: '' },
    predictionLabel: {
      ar: 'توقّعك',
      en: 'Your pick',
    },
    predictionHint: {
      ar: 'اختر من القائمة المنسدلة',
      en: 'Pick from the dropdown',
    },
    next: { ar: 'التالي', en: 'Next' },
    back: { ar: 'رجوع', en: 'Back' },
    submit: { ar: 'ابدأ المحادثة', en: 'Start chat' },
    skipPrediction: { ar: 'تخطّي', en: 'Skip' },
    errors: {
      name: { ar: 'الرجاء إدخال اسمك', en: 'Please enter your name' },
      prediction: { ar: 'الرجاء اختيار جامعة', en: 'Please pick a university' },
    },
    footer: {
      ar: 'جميع الأسئلة مرتبطة بمناقصات منصة اعتماد فقط',
      en: 'All questions must relate to Etimad tenders',
    },
  },
  chat: {
    headerTitle: { ar: 'مرصد اعتماد', en: 'Marsad Etimad' },
    headerExit: { ar: 'خروج', en: 'Exit' },
    placeholder: { ar: 'اكتب سؤالك عن المناقصات…', en: 'Ask a tender question…' },
    send: { ar: 'إرسال', en: 'Send' },
    welcome: {
      ar: 'مرحباً — اسألني عن المناقصات، أو الصق نطاق مشروع لأقدّر قيمته.',
      en: 'Welcome — ask about tenders, or paste a project scope for a value estimate.',
    },
    tryQuestion: { ar: 'جرّب سؤالاً:', en: 'Try a question:' },
    suggestions: [
      { ar: 'ما أعلى 3 مناقصات لجامعة الإمام عبدالرحمن بن فيصل في 2024؟', en: 'Top 3 tenders at Imam Abdulrahman Bin Faisal University (IAU) in 2024?' },
      { ar: 'من أكبر الفائزين بعقود الصيانة في الجامعات السعودية؟', en: 'Who are the biggest winners of university maintenance contracts?' },
      { ar: 'كم بلغ إجمالي إنفاق الجامعات على تقنية المعلومات خلال 2024؟', en: 'How much did Saudi universities spend on IT tenders in 2024?' },
      { ar: 'قدّر قيمة: توريد وتركيب أجهزة مختبرات حاسوبية لأربع كليات مع صيانة لمدة 3 سنوات', en: 'Estimate: computer lab equipment for 4 colleges with 3-year maintenance' },
    ],
    stages: {
      classify: { ar: 'أتفهّم سؤالك…', en: 'Understanding your question…' },
      retrieve: { ar: 'أبحث في 9,447 مناقصة…', en: 'Searching 9,447 tenders…' },
      answer: { ar: 'أحضّر الإجابة…', en: 'Preparing your answer…' },
      'follow-up': { ar: 'أتابع معك…', en: 'Following up…' },
      cache: { ar: 'وجدت الإجابة…', en: 'Found it…' },
    },
    modeLabels: {
      A: { ar: 'بحث تاريخي', en: 'Historical lookup' },
      B: { ar: 'تحليل تقديري', en: 'Estimate analysis' },
    },
    errors: {
      rate: { ar: 'انتظر قليلاً قبل السؤال التالي', en: 'Slow down — please wait' },
    },
  },
  dashboard: {
    title: { ar: 'لوحة الورشة المباشرة', en: 'Live Workshop Dashboard' },
    badge: { ar: 'تطوير · ورشة مباشرة', en: 'Tatweer · Live Workshop' },
    live: { ar: 'مباشر', en: 'Live' },
    connecting: { ar: 'جارٍ الاتصال', en: 'Connecting' },
    disconnected: { ar: 'انقطع الاتصال', en: 'Disconnected' },
    paused: { ar: 'متوقف', en: 'Paused' },
    circuitOpen: { ar: 'دائرة مفتوحة', en: 'Circuit open' },
    tiles: {
      connected: { ar: 'المتّصلون الآن', en: 'Live audience' },
      queries: { ar: 'إجمالي الأسئلة', en: 'Total queries' },
      modeA: { ar: 'استعلامات تاريخية', en: 'Historical lookups' },
      votes: { ar: 'توقّعات الحضور', en: 'Audience votes' },
      refused: { ar: 'رفض نطاق', en: 'Out of scope' },
      cost: { ar: 'التكلفة', en: 'Cost so far' },
    },
    feed: { ar: 'آخر الأسئلة', en: 'Latest questions' },
    feedEmpty: {
      ar: 'لا توجد أسئلة حتى الآن — في انتظار أول سؤال',
      en: 'No questions yet — waiting for the first one',
    },
    feedLast: { ar: 'آخر 20', en: 'last 20' },
    predictions: { ar: 'توقّعات الحضور', en: 'Audience predictions' },
    predictionsSubtitle: {
      ar: 'أي جامعة تتصدّر بإجمالي قيمة مناقصاتها على اعتماد؟',
      en: 'Which university leads by total tender value on Etimad?',
    },
    revealTitle: { ar: 'الإجابة الفعلية', en: 'Actual leader' },
    predictionsReceived: { ar: 'توقعاً', en: 'predictions' },
    tabs: {
      live: { ar: 'مباشر', en: 'Live' },
      advanced: { ar: 'متقدّم', en: 'Advanced' },
    },
    qrCta: { ar: 'انضم بمسح الرمز', en: 'Join · scan QR' },
    advancedTiles: {
      cost: { ar: 'التكلفة المقدّرة', en: 'Cost so far' },
      cacheHits: { ar: 'استرجاع من الذاكرة', en: 'Cache hits' },
      cacheSize: { ar: 'حجم ذاكرة المصنّف', en: 'Classifier cache size' },
      provider: { ar: 'المزوّد', en: 'Provider' },
      modeBModel: { ar: 'نموذج التحليل', en: 'Mode B model' },
      throttle: { ar: 'إبطاء (ms)', en: 'Throttle (ms)' },
      rateLimit: { ar: 'الحدّ لكل دقيقة', en: 'Rate / minute' },
      feedback: { ar: 'ملاحظات المستخدمين', en: 'User reports' },
    },
  },
  admin: {
    title: { ar: 'لوحة التحكم', en: 'Admin' },
    login: { ar: 'أدخل كلمة السر', en: 'Enter password' },
    pause: { ar: 'إيقاف', en: 'Pause' },
    resume: { ar: 'استئناف', en: 'Resume' },
    reset: { ar: 'إعادة ضبط', en: 'Reset counters' },
    triggerReveal: { ar: 'عرض النتيجة', en: 'Trigger reveal' },
    endReveal: { ar: 'إنهاء العرض', en: 'End reveal' },
    provider: { ar: 'المزود', en: 'Provider' },
    modeB: { ar: 'نموذج التحليل', en: 'Mode B model' },
    export: { ar: 'تصدير السجل', en: 'Export log' },
  },
} as const;

export function t<K1 extends keyof typeof STRINGS, K2 extends keyof (typeof STRINGS)[K1]>(
  k1: K1,
  k2: K2,
  lang: Lang = 'ar',
): string {
  const entry = (STRINGS[k1] as Record<string, unknown>)[k2 as string] as { ar: string; en: string };
  return entry[lang];
}
